import { useTranslation } from "react-i18next";

import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Tooltip from "@mui/material/Tooltip";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import BuildIcon from "@mui/icons-material/Build";
import FlightIcon from "@mui/icons-material/Flight";
import SchoolIcon from "@mui/icons-material/School";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import WorkIcon from "@mui/icons-material/Work";

import Button from "../Button";

import { useCrewMembersActions } from "../../context/CrewMembersActionsContext";

const UserActions = ({ userId }) => {
  const { t } = useTranslation();
  const actions = useCrewMembersActions();

  return (
    <Button
      title={t("assign_member_properties_and_aircraft")}
      icon={<AccountCircleIcon />}
      onClick={() => actions.properties(userId)}
    />
  );
};

const UserProperties = ({ userId }) => {
  const actions = useCrewMembersActions();
  const { t } = useTranslation();
  return (
    <>
      <Button title={t("user_positions")} icon={<WorkIcon />} onClick={() => actions.positions(userId)} />
      <Button title={t("user_operations")} icon={<BuildIcon />} onClick={() => actions.operations(userId)} />
      <Button title={t("user_aircraft")} icon={<FlightIcon />} onClick={() => actions.aircraft(userId)} />
      <Button title={t("all_certificates")} icon={<SchoolIcon />} onClick={() => actions.allCertificates(userId)} />
    </>
  );
};

export const UserRow = ({ user }) => {
  const { t } = useTranslation();
  const actions = useCrewMembersActions();

  return (
    <>
      <TableRow key={user.id}>
        <TableCell>{user.id}</TableCell>
        <TableCell>
          <Box
            component="span"
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 0.5,
            }}
          >
            {user.fullname}
            {user.profileSetupIncomplete && (
              <Tooltip
                title={`${t("compliance.profile_setup_incomplete_title")} — ${t("compliance.edit_user_properties")}`}
              >
                <IconButton
                  size="small"
                  onClick={() => actions.properties(user.id)}
                  aria-label={t("compliance.profile_setup_incomplete_title")}
                >
                  <WarningAmberIcon fontSize="small" color="warning" />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        </TableCell>
        <TableCell>{user.email}</TableCell>
        <TableCell>{user.roles?.join(", ")}</TableCell>
        <TableCell>
          <UserProperties userId={user.id} />
        </TableCell>
        <TableCell>
          <UserActions userId={user.id} />
        </TableCell>
      </TableRow>
    </>
  );
};
